import React, { useState } from "react";
import { formatToDecimal } from "utils/formatNumber";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import useAuth from "hooks/useAuth";
import useSubscription from "hooks/useSubscription";
const RentalTabContent = ({ property }) => {
  const grossYield = Number(property?.gross_yield);
  const averageGrossYield = Number(property?.average_gross_yield);
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  const percentageDifference =
    averageGrossYield !== 0
      ? ((grossYield - averageGrossYield) / averageGrossYield) * 100
      : 0;

  const isYieldAboveAverage = grossYield > averageGrossYield;

  const yieldBackgroundColor = isYieldAboveAverage ? "#C0D4BF" : "#FF718B";
  const yieldButtonColor = isYieldAboveAverage ? "#E8EAE8" : "#EAE9E8";
  const yieldTextColor = isYieldAboveAverage ? "#337731" : "#FF718B";

  return (
    <div className="mt-[19px]">
      <div className="flex items-center justify-between">
        <h2 className="text-[16px] md:text-[18px] lg:text-[22px] font-bold leading-[28px] text-black line-clamp-1">
          Rendita Locativa
        </h2>
        <span
          className="cursor-pointer"
          data-tooltip-id="not_subscribed_tooltip"
          data-tooltip-content="È una stima da agenzie indipendenti che analizzano diversi indicatori di mercato per valutare quanto potrebbe rendere la proprietà se messa in affitto su base annuale"
        >
          <InfoIcon />
        </span>
        {/* Info Tooltip  */}
        <ReactTooltip
          id="not_subscribed_tooltip"
          place="top"
          positionStrategy="fixed"
          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
        />
      </div>
      <div className="mt-[13px] grid gap-2 sm:gap-3">
        <div className="bg-[#3377314D] h-[94px] rounded-[9px] flex items-center justify-between gap-4 sm:gap-[34px] p-3 pl-[21px]">
          <p className="text-[#FFFFFF] text-[15px] sm:text-[18px] font-semibold leading-[20px]">
            Il ritorno sull’investimento annuale è stimato
          </p>
          <div className="max-w-[115px] sm:max-w-[139px] h-[70px]">
            <div
              data-tooltip-id="estimated_return_tooltip"
              data-tooltip-content="Il ritorno sull'investimento è stimato da agenzie indipendenti che analizzano diversi indicatori di mercato per valutare quanto potrebbe rendere la proprietà se messa in affitto"
              className="bg-[#E8EAE8] cursor-pointer rounded-[10px] flex items-center justify-center h-full text-center w-[115px] sm:w-[139px] text-[25px] sm:text-[32px] font-bold text-[#337731]"
            >
              {user && isPremium ? (
                `${property?.gross_yield}%`
              ) : (
                <span className="pt-3">****</span>
              )}
            </div>
            {user && isPremium && (
              //  Info Tooltip
              <ReactTooltip
                id="estimated_return_tooltip"
                place="top"
                positionStrategy="fixed"
                className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
              />
            )}
          </div>
        </div>
        <div
          className="h-full rounded-[9px] p-3 pl-[21px] pt-[19px]"
          style={{ background: yieldBackgroundColor }}
        >
          <p className="text-[#FFFFFF] text-[15px] sm:text-[18px] font-semibold leading-[25px]">
            {isYieldAboveAverage
              ? "Questa proprietà ha un ritorno sull’investimento superiore rispetto ad altre proprietà che si trovano nella stessa zona."
              : "Questa proprietà ha un ritorno sull’investimento inferiore rispetto ad altre proprietà che si trovano nella stessa zona."}
          </p>
          <div className="ml-auto max-w-fit sm:min-w-[139px] h-[70px]">
            <div
              data-tooltip-id="local_comparison_tooltip"
              data-tooltip-content={
                isYieldAboveAverage
                  ? `Nella zona ${
                      property?.location?.name
                    } questa proprietà ha un ROI del ${formatToDecimal(
                      percentageDifference
                    )}% superiore alla media`
                  : `Nella zona ${
                      property?.location?.name
                    } questa proprietà ha un ROI del ${formatToDecimal(
                      percentageDifference
                    )}% inferiore rispetto alla media`
              }
              className="cursor-pointer w-full h-full rounded-[10px] flex items-center justify-center text-center px-[21px] text-[25px] sm:text-[32px] font-bold"
              style={{
                background: yieldButtonColor,
                color: yieldTextColor,
              }}
            >
              {user && isPremium ? (
                `${formatToDecimal(percentageDifference)}%`
              ) : (
                <span className="pt-3">****</span>
              )}
            </div>

            {user && isPremium && (
              //  Info Tooltip
              <ReactTooltip
                id="local_comparison_tooltip"
                place="top"
                positionStrategy="fixed"
                className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentalTabContent;
